export const SET_AUTO_SIGN_OUT = 'SET_AUTO_SIGN_OUT'
export const RESET_AUTO_SIGN_OUT = 'RESET_AUTO_SIGN_OUT'
